// extracted by mini-css-extract-plugin
module.exports = {"container":"ConferenceItem_container__yZ8_l"};